@if (_content && !_hideBanner()) {
  <div class="banner-container" [class]="type">
    <div>{{ _content.status }}</div>

    @if (_content.details?.length) {
      <ul>
        @for (detail of _content.details; track $index) {
          <li>{{ detail }}</li>
        }
      </ul>
    }

    @if (_content.links?.length) {
      <div class="links-container">
        @for (link of _content.links; track link.label) {
          <myre-click-or-link
            class="link"
            [externalLink]="link.externalLink"
            [link]="link.routerLink"
            [queryParams]="link.queryParams"
            [aria-label]="link.ariaLabel"
            (onClick)="link.onClick($event)"
          >
            <div class="link__content">
              <span class="text">{{ link.label }}</span>
              @if (link.externalLink) {
                <i class="myre-icon-launch"></i>
              }
            </div>
          </myre-click-or-link>
        }
      </div>
    }

    @if (copyToClipboard()) {
      <i class="myre-icon-copy copy-button" [class]="type" (click)="copy()"></i>
    }

    @if (closable()) {
      <i
        class="myre-icon-close close-button"
        [class]="type"
        (click)="_onClose()"
      >
      </i>
    }
  </div>
}
